import React, { useEffect, useState } from 'react';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.getElementById('hero-section');
      const pricingSection = document.getElementById('pricing');
      if (!heroSection || !pricingSection) return;
      const heroBottom = heroSection.getBoundingClientRect().bottom;
      const pricingTop = pricingSection.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;
      if (heroBottom < 0 && pricingTop > windowHeight) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed bottom-0 left-0 right-0 z-40 bg-bg-dark border-t border-border-light p-4 transition-[transform,opacity] duration-300 ease-in-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0 pointer-events-none'}`} data-id="element-214">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-215">
        <div className="text-center sm:text-left" data-id="element-216">
          <p className="text-text-main font-bold text-sm sm:text-lg" data-id="element-217">
            BASKETBALL-FIX
          </p>
          <p className="text-secondary font-black text-lg sm:text-xl" data-id="element-218">
            19,90 €
          </p>
        </div>
        <a href="#pricing" className="btn-primary-pulse bg-cta-green text-gray-900 font-black px-6 sm:px-8 py-3 rounded-xl hover:bg-cta-green-hover transition-colors shadow-[0_0_15px_rgba(16,185,129,0.3)] w-full sm:w-auto text-center text-sm sm:text-base border border-white/10" data-id="element-219">
          🚀 JA! ICH WILL MEINE ZEIT ZURÜCKHOLEN
        </a>
      </div>
    </div>;
}